import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-asset-budgeting',
  templateUrl: './asset-budgeting.component.html',
  styleUrls: ['./asset-budgeting.component.css']
})
export class AssetBudgetingComponent implements OnInit {

  assetBudgetingDataList: any = [];
  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  isLoading = false;
  id: any;

  addForm!: FormGroup;
  updateForm!: FormGroup;
  formSubmit = false;
  isEdit = false;

  cid: any;
  assetBudgetingData: any = [];

  locationList: any[] = [];
  branchList: any[] = [];
  uomData: any[] = [];
  yearList: any[] = [];
  objectInfoList: any[] = [];

  financialYear: any;

  searchFilter: string = "";
  recordId: any = "";
  recordName: any = "";

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  };

  constructor(
    private generic_service: GenericService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const href = window.location.href;
    const messages = href.split('/');
    const action = this.generic_service.checkActionControls(messages[messages.length - 1]);
    this.actionControls = action;

    this.cid = Number(sessionStorage.getItem('cid'));

    this.initializeForms();
    this.getAllAssetBudgeting();
    this.getAllLocation();
    this.getAllBranch();
    this.getAllUomMaster();
    this.getAllObjectInfo();

    this.financialYear = new Date().getFullYear();
    this.generateYearList(2020, this.financialYear);
  }

  private initializeForms(): void {
    this.addForm = this.fb.group({
      branch: ['', Validators.required],
      financialYear: ['', Validators.required],
      location: [''],
      budgetData: this.fb.array([this.createBudgetDataGroup()])
    });

    this.updateForm = this.fb.group({
      branch: ['', Validators.required],
      financialYear: ['', Validators.required],
      location: [''],
      budgetData: this.fb.array([])
    });
  }

  private createBudgetDataGroup(): FormGroup {
    return this.fb.group({
      version: [0],
      isActive: [true],
      description: [''],
      assetName: ['', Validators.required],
      noOfUnits: ['', Validators.required],
      pricePerUnit: ['', Validators.required],
      totalValue: ['', Validators.required],
      currency: ['', Validators.required],
      uom: ['', Validators.required]
    });
  }

  get budgetData(): FormArray {
    return this.addForm.get('budgetData') as FormArray;
  }

  get budgetUpdateData(): FormArray {
    return this.updateForm.get('budgetData') as FormArray;
  }

  addBudgetItem(): void {
    this.budgetData.push(this.createBudgetDataGroup());
  }

  removeBudgetItem(index: number): void {
    this.budgetData.removeAt(index);
  }

  addUpdateBudgetItem(): void {
    this.budgetUpdateData.push(this.createBudgetDataGroup());
  }

  removeUpdateBudgetItem(index: number): void {
    this.budgetUpdateData.removeAt(index);
  }

  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe((response: any) => {
      this.uomData = response.response;
    });
  }

  getAllObjectInfo() {
    this.generic_service.getAllObjectInfo().subscribe((response: any) => {
      this.objectInfoList = response.response;
    });
  }

  generateYearList(fromYear: number, toYear: number): void {
    this.yearList = [];
    for (let year = fromYear; year <= toYear; year++) {
      this.yearList.push({ year });
    }
  }

  getAllBranch() {
    this.generic_service.getBranch().subscribe((response: any) => {
      this.branchList = response.response;
    });
  }

  getAllLocation() {
    this.generic_service.getAllLocation().subscribe((response: any) => {
      this.locationList = response.response;
    });
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  getAllAssetBudgeting() {
    this.isLoading = true;
    this.generic_service.getAllAssetBudgeting().subscribe((response: any) => {
      this.assetBudgetingDataList = response.response;
      this.totalRecords = response.response.length;
      this.isLoading = false;
    });
  }

  getAssetBudgetingIdById(assetBudgetingId: any) {
    this.generic_service.getAssetBudgetingIdById(assetBudgetingId).subscribe((response: any) => {
      const data = response.response;
      this.assetBudgetingData = [data];

      this.updateForm.patchValue({
        branch: data.branch,
        financialYear: data.financialYear,
        location: data.location
      });

      this.budgetUpdateData.clear();
      data.budgetData.forEach((item: any) => {
        this.budgetUpdateData.push(this.createBudgetItemGroup(item));
      });

      this.isEdit = true;
    });
  }

  createBudgetItemGroup(item: any): FormGroup {
    return this.fb.group({
      version: [item.version ?? 0],
      isActive: [item.isActive ?? true],
      description: [item.description ?? ''],
      assetName: [item.assetName ?? '', Validators.required],
      noOfUnits: [item.noOfUnits ?? '', Validators.required],
      pricePerUnit: [item.pricePerUnit ?? '', Validators.required],
      totalValue: [item.totalValue ?? '', Validators.required],
      currency: [item.currency ?? '', Validators.required],
      uom: [item.uom ?? '', Validators.required]
    });
  }

  cancelModel() {
    document.getElementById("closeModalAdd")?.click();
    document.getElementById("closeModalUpdate")?.click();
    document.getElementById("closeModalDelete")?.click();
  }

  deleteIdSelect(id: any, list: any) {
    this.id = id;
    this.recordId = list.assetBudgetingId;
    this.recordName = list.financialYear;
  }

  deleteAssetBudgeting() {
    this.generic_service.deleteAssetBudgeting(this.id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllAssetBudgeting();
        this.cancelModel();
      },
      err => {
        this.toastr.error(err?.error?.errors?.[0]?.description || "Delete failed");
      }
    );
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    this.getAllAssetBudgeting();
  }

  getAllAssetDepreciationMethodByWildSearch() {
    if (!this.searchFilter) return;

    this.generic_service.getAllAssetDepreciationMethodByWildSearch(this.searchFilter).subscribe(
      (response: any) => {
        if (!response.response || response.response.length === 0) {
          this.assetBudgetingDataList = [];
          this.totalRecords = 0;
          return;
        }
        this.assetBudgetingDataList = response.response;
        this.totalRecords = response.response.length;
      },
      err => {
        console.log(err);
      }
    );
  }

  addAssetBudgeting() {
    if (this.formSubmit) return;

    if (!this.addForm.valid) {
      this.toastr.error("Please fill in all required fields");
      return;
    }

    this.formSubmit = true;

    const formValue = this.addForm.value;
    const body = {
      version: 0,
      isActive: true,
      description: '',
      cid: this.cid,
      branch: formValue.branch,
      financialYear: formValue.financialYear,
      location: formValue.location,
      budgetData: formValue.budgetData
    };

    this.generic_service.addAssetBudgeting(body).subscribe(
      (response: any) => {
        this.formSubmit = false;
        this.addForm.reset();
        this.cancelModel();
        this.resetForm();
        this.getAllAssetBudgeting();
        this.toastr.success(response.message);
      },
      err => {
        this.formSubmit = false;
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Submission failed');
      }
    );
  }

  updateAssetBudgeting() {
    if (this.formSubmit) return;

    if (!this.updateForm.valid) {
      this.toastr.error("Please fill in all required fields");
      return;
    }

    this.formSubmit = true;

    const formValue = this.updateForm.value;
    const body = {
      version: 0,
      isActive: true,
      description: '',
      id: this.assetBudgetingData[0].id,
      assetBudgetingId: this.assetBudgetingData[0].assetBudgetingId,
      cid: this.cid,
      branch: formValue.branch,
      financialYear: formValue.financialYear,
      location: formValue.location,
      budgetData: formValue.budgetData
    };

    this.generic_service.updateAssetBudgeting(body).subscribe(
      (response: any) => {
        this.isEdit = false;
        this.cancelModel();
        this.resetForm();
        this.getAllAssetBudgeting();
        this.toastr.success(response.message);
      },
      err => {
        this.toastr.error(err?.error?.errors?.[0]?.description || "Update failed");
      }
    );
  }

  resetForm(): void {
    this.addForm.reset();
    this.updateForm.reset();
    this.clearBudgetData();
    this.addBudgetItem();
  }

  private clearBudgetData(): void {
    this.budgetData.clear();
    this.budgetUpdateData.clear();
  }

  // Used to auto-calculate total value
  // calculateTotal(index: number, form: FormArray) {
  //   const item = form.at(index);
  //   const units = +item.get('noOfUnits')?.value || 0;
  //   const price = +item.get('pricePerUnit')?.value || 0;
  //   item.get('totalValue')?.setValue(units * price);
  // }

calculateTotal(index: number) {
  const item = this.budgetData.at(index);
  const units = +item.get('noOfUnits')?.value || 0;
  const price = +item.get('pricePerUnit')?.value || 0;
  item.get('totalValue')?.setValue(units * price);
}

  editAssetBudget(data: any): void {
    this.updateForm.patchValue({
      branch: data.branch,
      financialYear: data.financialYear,
      location: data.location
    });

    this.budgetUpdateData.clear();

    data.budgetData.forEach((item: any) => {
      this.budgetUpdateData.push(this.createBudgetItemGroup(item));
    });

    this.isEdit = true;
  }

  closeModal(): void {
    this.addForm.reset();
    this.budgetData.clear();
    this.addBudgetItem()
  }

}
